<script>
    import { onMount } from 'svelte'
    import convert from 'color-convert'

    let pieceTexture0 = './images/piece/texture0.png'
    let pieceTexture1 = './images/piece/texture1.png'
    let pieceTexture2 = './images/piece/texture2.png'
    let pieceTexture3 = './images/piece/texture3.png'
    let pieceTexture4 = './images/piece/texture4.png'
    let pieceTexture5 = './images/piece/texture5.png'
    let pieceTexture6 = './images/piece/texture6.png'
    let pieceTexture7 = './images/piece/texture7.png'
    let pieceTexture8 = './images/piece/texture8.png'
    let pieceTexture9 = './images/piece/texture9.png'
    let pieceTexture10 = './images/piece/texture10.png'
    let pieceTexture11 = './images/piece/texture11.png'

    // Initialize color
    export let bgColor
    export let chosenPalette
    $: chosenColors = []
    let color1A = ""
    let color1B = ""
    let color1C = ""
    let color1D = ""
    let color2 = ""

    // Intialize layout
    let layout = "single"
    let layoutOptions = ["single", "triple", "quad"]

    // Initialize rotation
    let rotation = 0

    // Intialize radius(s)
    $: cornerSet1 = ""
    $: cornerSet2 = ""
    $: cornerSet3 = ""
    $: cornerSet4 = ""
    $: cornerSet5 = ""
    $: cutoutCornerSet = ""

    // Initialize cutout
    let cutoutEnabled = false
    let chosenCutout = "center"
    let cutoutOptions = ["center", "topLeft", "top", "topRight", "right", "bottomRight", "bottom", "bottomLeft", "Left"]
    let chosenCutoutStyle = ""

    // Initialize texture
    let textureEnabled = false
    let pieceTextures = [
        pieceTexture0,
        pieceTexture1,
        pieceTexture2,
        pieceTexture3,
        pieceTexture4,
        pieceTexture5,
        pieceTexture6,
        pieceTexture7,
        pieceTexture8,
        pieceTexture9,
        pieceTexture10,
        pieceTexture11,
    ]
    let textureImage = 1
    let textureSize = 100
    let textureRotation = 0
    let texturePositionOptions = ["left top", "left center", "left bottom", "right top", "right center", "right bottom", "center top", "center center", "center bottom"]
    let texturePosition = "center center"

    onMount(() => {

        // Determine Piece Colors
        let colorIndex = Math.floor( fxrand() * chosenPalette.colors.length )
        chosenColors.push(chosenPalette.colors[colorIndex])
        colorIndex = Math.floor( fxrand() * chosenPalette.colors.filter(m => m !== chosenColors[0]).length )
        chosenColors.push(chosenPalette.colors.filter(m => m !== chosenColors[0])[colorIndex])

        // Color modulation
        color1A = modulateColor(chosenColors[0])
        color1B = modulateColor(chosenColors[0])
        color1C = modulateColor(chosenColors[0])
        color1D = modulateColor(chosenColors[0])
        color2 = modulateColor(chosenColors[1])
        function modulateColor(hex) {
            hex = hex.substring(1)
            let hsl = convert.hex.hsl(hex)
            hsl = [hsl[0] + fxrand(), hsl[1] + fxrand(), hsl[2] + (fxrand() * 5)]
            hex = convert.hsl.hex(hsl[0], hsl[1], hsl[2])
            hex = "#" + hex
            return hex
        }

        // Determine layout
        layout = layoutOptions[Math.floor( fxrand() * layoutOptions.length )]

        // Determine rotation
        rotation = 90 * Math.floor( fxrand() * 3)

        // Determine peice radius(s)
        function getRadius(type) {
            let topLeft, topRight, bottomRight, bottomLeft = ""
            topLeft = getCorner(fxrand(), type)
            topRight = getCorner(fxrand(), type)
            bottomRight = getCorner(fxrand(), type)
            bottomLeft = getCorner(fxrand(), type)
            return "border-radius: " + topLeft + " " + topRight + " " + bottomRight + " " + bottomLeft + " "
        }
        function getCorner(rand, type) {
            if (rand > .5) {
                if (type == "square") {
                    return "50%"
                } else if (type == "rectangle") {
                    return "100vh"
                }
            }
            else {return "0"}
        }
        cornerSet1 = getRadius("square")
        cornerSet2 = getRadius("square")
        cornerSet3 = getRadius("square")
        cornerSet4 = getRadius("square")
        cornerSet5 = getRadius("rectangle")
        cutoutCornerSet = getRadius("square")

        // Determine cutout
        cutoutEnabled = fxrand() > .75
        if (cutoutEnabled) {
            chosenCutout = cutoutOptions[Math.floor( fxrand() * cutoutOptions.length )]
            if (chosenCutout == "topLeft") {chosenCutoutStyle = "justify-content: flex-start; align-items: flex-start; top: -25%; left: -25%"}
            else if (chosenCutout == "top") {chosenCutoutStyle = "justify-content: center; align-items: flex-start; top: -25%"}
            else if (chosenCutout == "topRight") {chosenCutoutStyle = "justify-content: flex-end; align-items: flex-start; top: -25%; right: -25%"}
            else if (chosenCutout == "right") {chosenCutoutStyle = "justify-content: flex-end; align-items: center; right: -25%;"}
            else if (chosenCutout == "bottomRight") {chosenCutoutStyle = "justify-content: flex-end; align-items: flex-end; right: -25%; bottom: -25%"}
            else if (chosenCutout == "bottom") {chosenCutoutStyle = "justify-content: center; align-items: flex-end; bottom: -25%"}
            else if (chosenCutout == "bottomLeft") {chosenCutoutStyle = "justify-content: flex-start; align-items: flex-end; bottom: -25%; left: -25%;"}
            else if (chosenCutout == "left") {chosenCutoutStyle = "justify-content: flex-start; align-items: center; left: -25%;"}
            else {chosenCutoutStyle = "justify-content: center; align-items: center; top: 0"}
        }

        // Determine texture
        if (fxrand() > .7) {textureEnabled = true;}
        if (textureEnabled) {
            textureImage = Math.floor( fxrand() * 11 ) // multiply by number of texture options. 0 index
            textureSize = (Math.floor(fxrand() * 3) * 100) + 200
            textureRotation = 90 * Math.floor( fxrand() * 3)
            texturePosition =  texturePositionOptions[ Math.floor(fxrand() * texturePositionOptions.length) ]
        }

    });

</script>

<style>
    .piece {
        width: 100%;
        height: auto;
        aspect-ratio: 1 / 1;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        position: relative;
        filter: url(#squiggle)
    }

    .flex-horizontal {
        display: flex;
        flex-direction: row;
    }

    .half {
        display: flex;
        flex-direction: column;
        width: 50%;
    }

    .cutout-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
    }
</style>

<div style="position:relative; transform: rotate({rotation}deg)">

    {#if layout == "single"}

        <div class="piece" style="background-color: {color1A}; {cornerSet1}">
            {#if textureEnabled}
                <div style="width: 100%; height: 100%; background-color: {color2};  -webkit-mask-image: url({pieceTextures[textureImage]}); -webkit-mask-size: {textureSize}%; -webkit-mask-position: {texturePosition}; transform: rotate({textureRotation}deg);}" ></div>
            {/if}
        </div>

    {:else if layout == "triple"}

        <div class="flex-horizontal">
            <div class="half">
                <div class="piece" style="background-color: {color1A}; {cornerSet5}; height: 100%;">
                    {#if textureEnabled}
                        <div style="left: 0; width: 200%; height: 100%; position: absolute; background-color: {color2}; -webkit-mask-image: url({pieceTextures[textureImage]}); -webkit-mask-size: {textureSize}%; -webkit-mask-position: {texturePosition};" ></div>
                    {/if}
                </div>
            </div>
            <div class="half">
                <div class="piece" style="background-color: {color1B}; {cornerSet2}">
                    {#if textureEnabled}
                        <div style="left: -100%; bottom: -100%; width: 200%; height: 200%; position: absolute; background-color: {color2}; -webkit-mask-image: url({pieceTextures[textureImage]}); -webkit-mask-size: {textureSize}%; -webkit-mask-position: {texturePosition}; " ></div>
                    {/if}
                </div>
                <div class="piece" style="background-color: {color1C}; {cornerSet3}">
                    {#if textureEnabled}
                        <div style="left: -100%; top: -100%; width: 200%; height: 200%; position: absolute; background-color: {color2}; -webkit-mask-image: url({pieceTextures[textureImage]}); -webkit-mask-size: {textureSize}%; -webkit-mask-position: {texturePosition}; " ></div>
                    {/if}
                </div>
            </div>
        </div>

    {:else if layout == "quad"}

        <div class="flex-horizontal">
            <div class="half">
                <div class="piece" style="background-color: {color1A}; {cornerSet1}">
                    {#if textureEnabled}
                        <div style="left: 0; bottom: -100%; width: 200%; height: 200%; position: absolute; background-color: {color2}; -webkit-mask-image: url({pieceTextures[textureImage]}); -webkit-mask-size: {textureSize}%; -webkit-mask-position: {texturePosition}; " ></div>
                    {/if}
                </div>
                <div class="piece" style="background-color: {color1B}; {cornerSet2}">
                    {#if textureEnabled}
                        <div style="left: 0; top: -100%; width: 200%; height: 200%; position: absolute; background-color: {color2}; -webkit-mask-image: url({pieceTextures[textureImage]}); -webkit-mask-size: {textureSize}%; -webkit-mask-position: {texturePosition}; " ></div>
                    {/if}
                </div>
            </div>
            <div class="half">
                <div class="piece" style="background-color: {color1C}; {cornerSet3}">
                    {#if textureEnabled}
                        <div style="left: -100%; bottom: -100%; width: 200%; height: 200%; position: absolute; background-color: {color2}; -webkit-mask-image: url({pieceTextures[textureImage]}); -webkit-mask-size: {textureSize}%; -webkit-mask-position: {texturePosition}; " ></div>
                    {/if}
                </div>
                <div class="piece" style="background-color: {color1D}; {cornerSet4}">
                    {#if textureEnabled}
                        <div style="left: -100%; top: -100%; width: 200%; height: 200%; position: absolute; background-color: {color2}; -webkit-mask-image: url({pieceTextures[textureImage]}); -webkit-mask-size: {textureSize}%; -webkit-mask-position: {texturePosition}; " ></div>
                    {/if}
                </div>
            </div>
        </div>

    {/if}

    {#if cutoutEnabled}
        <div class="cutout-wrapper" style="{chosenCutoutStyle}">
            <div style="width: 50%; height: auto; aspect-ratio: 1/1; background-color: {bgColor}; {cutoutCornerSet}"></div>
        </div>
    {/if}

</div>

<svg xmlns="http://www.w3.org/2000/svg" version="1.1" style="position: absolute" height="0px" width="0px">
    <defs>
        <filter id="squiggle">
            <feTurbulence type="turbulence" baseFrequency=".04" numOctaves="1" result="turbulence"/>
            <feDisplacementMap in2="turbulence" in="SourceGraphic" scale="1" xChannelSelector="R" yChannelSelector="G"/>
        </filter>
    </defs>
</svg>